import React from "react";
import Layout from "../components/layout/index";
import constants from "../constants";
import DailyCalendar from "../components/common/DailyCalendar/Index";
import Stats from "../components/common/Stats/Index";
import Course from "../components/common/Course/Index";
import News from "../components/common/News/Index";

const Dashboard = ({toast}) => {

  const title = constants.modules.dashboard;

  const toastD = React.useRef(toast);

  return (
    <Layout title={title} toast={toastD}>
      <div className="surface-0 text-700 m-3">
        <Stats />
        <DailyCalendar className="mr-3" />
        <div className="grid pt-3">
          <div className="col-12 lg:col-8">
            <Course />
          </div>
          <div className="col-12 lg:col-4">
            <News />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
